import {Component, Inject, Input, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-modal-dossier-equipement-add',
    templateUrl: './modal-confirm.component.html'
})
export class ModalConfirm {
    @Input() confirmationMessage: string;

    constructor(
        public dialogRef: MatDialogRef<ModalConfirm>,
    ) {
    }
}
